import { render, staticRenderFns } from "./speech-content.vue?vue&type=template&id=260b2d98&scoped=true"
import script from "./speech-content.vue?vue&type=script&lang=ts"
export * from "./speech-content.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260b2d98",
  null
  
)

export default component.exports